class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.addEventListener('pointerdown', this.captureOpeningScrollPosition.bind(this));
    this.summaryToggle.addEventListener('keydown', (event) => {
      if (event.code === 'Enter' || event.code === 'Space') this.captureOpeningScrollPosition();
    });
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
    this.overlayListener = (event) => { if (event.detail !== this && this.isOpen()) this.close(false); };
  }

  connectedCallback() { document.addEventListener('corso:overlay-open', this.overlayListener); }
  disconnectedCallback() { if (this.isOpen()) this.close(false); document.removeEventListener('corso:overlay-open', this.overlayListener); }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  captureOpeningScrollPosition() {
    if (this.isOpen()) return;
    this.openingScrollPosition = {
      left: window.scrollX,
      top: window.scrollY,
    };
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    document.dispatchEvent(new CustomEvent('corso:overlay-open', { detail: this }));
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.scrollPosition =
      this.openingScrollPosition || {
        left: window.scrollX,
        top: window.scrollY,
      };
    this.openingScrollPosition = null;
    this.bodyStyles = {
      left: document.body.style.left,
      paddingRight: document.body.style.paddingRight,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
    };

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.left = `-${this.scrollPosition.left}px`;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition.top}px`;
    document.body.style.width = '100%';
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;

    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])'),
      true
    );
  }

  close(focusToggle = true) {
    const scrollPosition = this.scrollPosition;
    const bodyStyles = this.bodyStyles;

    removeTrapFocus(focusToggle ? this.summaryToggle : null, true);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (bodyStyles) {
      Object.assign(document.body.style, bodyStyles);
    }
    if (scrollPosition) {
      window.scrollTo({
        behavior: 'instant',
        left: scrollPosition.left,
        top: scrollPosition.top,
      });
    }

    this.scrollPosition = null;
    this.bodyStyles = null;
    this.openingScrollPosition = null;
  }
}

customElements.define('details-modal', DetailsModal);
